export default __webpack_public_path__ + "4fdf160c63e19c357251669539018584.png";